import { useQuery, keepPreviousData } from '@tanstack/react-query';

import { legacyPortfoliosSelector } from './legacyPortfolioSelector';
import { queryKey, queryFn } from './queryFn';

type Response = ReturnType<typeof legacyPortfoliosSelector> & {
  isFetched: boolean;
  isFetching: boolean;
};
export type Portfolio = Response['entities'][string];

export default function useLegacyPortfolios(): Response {
  const {
    isFetched,
    isFetching,
    data = {
      keys: [],
      entities: {},
      canCreatePortfolio: false,
      totalHoldingsCount: 0,
    },
  } = useQuery({
    queryKey: [queryKey],
    queryFn,
    staleTime: Infinity,
    refetchOnMount: true,
    placeholderData: keepPreviousData,
    select: legacyPortfoliosSelector,
  });

  return {
    ...data,
    isFetched,
    isFetching,
  };
}
